module.exports = __webpack_public_path__ + "static/img/7.3a61dd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/7.png
// module id = c/1b
// module chunks = 0